<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <!-- <el-collapse v-model="collapseActiveName" accordion>
        <el-collapse-item name="1"> -->
          <!-- <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批123</el-badge>
          </template> -->
          <div>
            <el-tabs v-model="attendanceActiveName" type="card">
              <el-tab-pane label="待我审批" name="attendancePendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="attendancePendingApprovalTableHead" @seeExample="seeExample" :tableData="attendancePendingApprovalTableData" :operationArr="attendancePendingApprovalOperationArr" @electricApproveRow="attendanceApproveRow" @electricUnApproveRow="attendanceUnApproveRow" :total="attendancePendingApprovalTotal" :pageNum="attendancePendingApprovalPageNum" :pageSize="attendancePendingApprovalPageSize" @changePagination="changeAttendancePendingApprovalPagination"  />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="attendanceApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="attendanceApprovedTableHead" @seeExample="seeExample" :tableData="attendanceApprovedTableData" :operationArr="attendanceApprovedOperationArr" :total="attendanceApprovedTotal" :pageNum="attendanceApprovedPageNum" :pageSize="attendanceApprovedPageSize" :hasOperation="false" @changePagination="changeAttendanceApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="attendanceSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="attendanceSponsoredTableHead" @seeExample="seeExample" :tableData="attendanceSponsoredTableData" :operationArr="attendanceSponsoredOperationArr" :total="attendanceSponsoredTotal" :pageNum="attendanceSponsoredPageNum" :pageSize="attendanceSponsoredPageSize" :hasOperation="false" @changePagination="changeAttendanceSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        <!-- </el-collapse-item>
      </el-collapse> -->
    </div>

    <!--考勤审批通过-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveAttendanceDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="attendanceMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAttendanceApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passAttendanceSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--考勤审批驳回-->
    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveAttendanceRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="attendanceMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAttendanceReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassAttendanceSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog title="审批进度" :visible.sync="flowDialog" style="margin-top:200px;">
      <el-steps :active="currentRate" align-center finish-status="success">
        <el-step :title="applyData.status=='4'?applyData.sponsorAccountName+'已撤回':applyData.sponsorAccountName+'发起审批'" :description="applyData.sponsorDate"></el-step>
        <el-step v-if="applyData.status!='4'" v-for="(item, index) in flowData" :key="item.code" :title="item.statusText" :description="item.approveDate" :status="item.status&&item.status!='0'?item.status=='2' ? 'error' : 'success':''"></el-step>
      </el-steps>
    </el-dialog>


  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import { api } from "../../api/WorkbenchApproval";

export default {
  components: {
    TableMain,
    Breadcrumb,
  },
  name: "workbench-approval",
  data() {
    return {
      yqCode: "",
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval",
        },
        {
          value: "考勤审批",
        },
      ],
      collapseActiveName: "",
      attendanceItemTitle: "考勤审批",
      accountCode: "",
      activeName: "pendingApproval",
      attendanceActiveName: "attendancePendingApproval",

      // 投诉建议
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名",
        },
        {
          prop: "personPhone",
          label: "手机号",
        },
        {
          prop: "roomNumber",
          label: "房间号",
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
        },
        {
          prop: "type",
          label: "类型",
        },
        {
          prop: "createTime",
          label: "提交时间",
        },
        {
          prop: "statusText",
          label: "状态",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      operationArr: ["modifySuggestions"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: "",
        searchKey: "",
        result: "",
        status: "0",
      },

      attendanceApproveData: {},
      attendanceUnApproveData: {},
      approveAttendanceDialog: false,
      approveAttendanceRejectDialog: false,
      attendanceMemo: "",

      // 我发起的(考勤)
      attendanceSponsoredTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "approveAccountName",
          label: "处理人",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      attendanceSponsoredTableData: [],
      attendanceSponsoredOperationArr: ["details"],
      attendanceSponsoredTotal: 0,
      attendanceSponsoredPageNum: 1,
      attendanceSponsoredPageSize: 10,

      // 待我审批(考勤)
      attendancePendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      attendancePendingApprovalTableData: [],
      attendancePendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      attendancePendingApprovalTotal: 0,
      attendancePendingApprovalPageNum: 1,
      attendancePendingApprovalPageSize: 10,

      // 我已审批(考勤)
      attendanceApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "approveDate",
          label: "审批时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      attendanceApprovedTableData: [],
      attendanceApprovedOperationArr: ["details"],
      attendanceApprovedTotal: 0,
      attendanceApprovedPageNum: 1,
      attendanceApprovedPageSize: 10,

      flowDialog:false,
      applyData:{},
      chainList:[],
      flowData:{},
      currentRate:0
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.requestData.responsiblePersonCode = bus.global.accountCode;
    this.accountCode = bus.global.accountCode;
    this.getPageByAttendancePendingApprovalPage();
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType;
    }
  },
  methods: {
    // 跳转审批详情页面
    toDetailsPage(data) {
      sessionStorage.setItem("workDetailData", JSON.stringify(data));
      sessionStorage.setItem("workDetailActiveName", this.activeName);
      if (data.type === "其他合同") {
        this.$router.push({
          name: "other-approval-detail",
        });
      } else {
        this.$router.push({
          name: "approval-detail",
        });
      }
    },
    // 我发起的页码跳转(考勤)
    changeAttendanceSponsoredPagination(data) {
      this.attendanceSponsoredPageNum = data[0];
      this.attendanceSponsoredPageSize = data[1];
      this.getPageByAttendanceSponsorAccountCode();
    },

    // 待我审批页码跳转(考勤)
    changeAttendancePendingApprovalPagination(data) {
      this.attendancePendingApprovalPageNum = data[0];
      this.attendancePendingApprovalPageSize = data[1];
      this.getPageByAttendancePendingApprovalPage();
    },

    // 我已审批页码跳转(考勤)
    changeAttendanceApprovedPagination(data) {
      this.attendanceApprovedPageNum = data[0];
      this.attendanceApprovedPageSize = data[1];
      this.getPageByAttendanceApprovedPage();
    },

    // 我发起的(考勤)
    getPageByAttendanceSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.attendanceSponsoredPageNum;
      reqData.pageSize = this.attendanceSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getAttendanceApprovePageBySponsorAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              v.approveAccountName =
                v.eventApproveChinaStatuses[0].approveAccountName;
              if (v.eventApproveChinaStatuses[0].approveDate) {
                v.approveDate = v.eventApproveChinaStatuses[0].approveDate.slice(
                  0,
                  19
                );
              }
              if (v.eventApproveChinaStatuses[0].approveStatus === "0") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (v.eventApproveChinaStatuses[0].approveResult === "1") {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.eventApproveChinaStatuses[0].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                }
              }
            });
            this.attendanceSponsoredTotal = res.data.data.total;
            this.attendanceSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(考勤)
    getPageByAttendancePendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.attendancePendingApprovalPageNum;
      reqData.pageSize = this.attendancePendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getAttendanceApprovePageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.eventApproveChainStatusCode =
                v.eventApproveChinaStatuses[0].code;
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.eventApproveChinaStatuses[0].status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.eventApproveChinaStatuses[0].status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.eventApproveChinaStatuses[0].status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.attendancePendingApprovalTotal = res.data.data.total;
            this.attendancePendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(考勤)
    getPageByAttendanceApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.attendanceApprovedPageNum;
      reqData.pageSize = this.attendanceApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "1";
      this.$axios
        .post(api.getAttendanceApprovePageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.approveAccountName =
                v.eventApproveChinaStatuses[0].approveAccountName;
              if (v.eventApproveChinaStatuses[0].approveDate) {
                v.approveDate = v.eventApproveChinaStatuses[0].approveDate.slice(
                  0,
                  19
                );
              }
              if (v.eventApproveChinaStatuses[0].approveStatus === "0") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (v.eventApproveChinaStatuses[0].approveResult === "1") {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.eventApproveChinaStatuses[0].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                }
              }
            });
            this.attendanceApprovedTotal = res.data.data.total;
            this.attendanceApprovedTableData = data;
            console.log(this.attendanceApprovedTableData);
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 考勤审批通过
    attendanceApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.attendanceApproveData = data;
      this.approveAttendanceDialog = true;
    },
    // 考勤审批驳回
    attendanceUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.attendanceUnApproveData = data;
      this.approveAttendanceRejectDialog = true;
    },

    // 取消通过
    cancelAttendanceApprove() {
      this.attendanceMemo = "";
      this.approveAttendanceDialog = false;
    },

    // 确认通过
    passAttendanceSubmit() {
      this.attendanceApproveData.memo = this.attendanceMemo;
      this.$axios
        .post(api.passSubmitAttendanceApprove, this.attendanceApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.attendanceMemo = "";
            this.approveAttendanceDialog = false;
            nSuccess("审批已通过");
            this.getPageByAttendancePendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    cancelAttendanceReject() {
      this.attendanceMemo = "";
      this.approveAttendanceRejectDialog = false;
    },

    // 确认驳回
    unpassAttendanceSubmit() {
      this.attendanceUnApproveData.memo = this.attendanceMemo;
      this.$axios
        .post(api.unPassSubmitAttendanceApprove, this.attendanceUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.attendanceMemo = "";
            this.approveAttendanceRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByAttendancePendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },

    seeExample(data){
      this.$axios.post(api.getAttendanceApproveFlow, {code: data.code}).then(res=>{
        this.applyData=res.data.data.apply
        this.chainList=res.data.data.statusList
        this.flowData=res.data.data.flow.flowDetails
        if(this.applyData.status && this.applyData.status=='4'){
          this.flowDialog=true;
          this.currentRate=0
          return;
        }
        this.flowData.map(u=>{
          u.statusText=u.accountName
          this.chainList.map(v=>{
            if(v.approveAccountCode==u.accountCode){
              u.approveDate=v.approveDate
              u.status=v.approveResult
              if(v.approveResult=='1'){
                u.statusText=u.accountName+'已通过'
              } else if(v.approveResult=='2'){
                u.statusText=u.accountName+'已驳回'
              }
            }
          })
        })
        this.flowData.map(v=>{
          let accountCode = v.accountCode;
          this.chainList.map(u=>{
            if(accountCode == u.approveAccountCode){
              if(u.approveStatus=='0'){
                this.currentRate =+ u.level;
              }else{
                this.currentRate =+ u.level+1;
              }
            }
          })
        })
        // this.flowData.map(v=>{
        //   if(v.accountCode==this.chainList[0].approveAccountCode){
        //     if(this.chainList[0].approveStatus=='0'){
        //       this.currentRate=+this.chainList[0].level
        //     }else{
        //       this.currentRate=+this.chainList[0].level+1
        //     }
        //   }
        // })
        this.flowDialog=true
      }).catch(errorHandler("获取审批进度失败"))
    }
  },
  watch: {
    attendanceActiveName(val) {
      if (val === "attendanceSponsored") {
        this.attendanceSponsoredPageNum = 1;
        this.attendanceSponsoredPageSize = 10;
        this.getPageByAttendanceSponsorAccountCode();
      } else if (val === "attendancePendingApproval") {
        this.attendancePendingApprovalPageNum = 1;
        this.attendancePendingApprovalPageSize = 10;
        this.getPageByAttendancePendingApprovalPage();
      } else if (val === "attendanceApproved") {
        this.attendanceApprovedPageNum = 1;
        this.attendanceApprovedPageSize = 10;
        this.getPageByAttendanceApprovedPage();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
  /deep/ .el-step__description {
    margin-top:-8em;
  }
  /deep/ .el-dialog__body{
    padding:60px 0 ;
    color: #1362FF ;
  }
  /deep/.el-step__head.is-success{
    color: #1362FF ;
    border-color: #1362FF ;
  }
  /deep/.el-step__title.is-success{
    color: #1362FF ;
  }
  /deep/.el-step__description.is-success{
    color:#1362FF ;
  }
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/AttendanceApproval/AttendanceApproval.vue